
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

// Images
import bgImage from "assets/images/contribute.jpg";

function Download() {
  return (
    <MKBox component="section" py={{ xs: 0, sm: 12 }}>
      <MKBox
        variant="gradient"
        bgColor="dark"
        position="relative"
        borderRadius="xl"
        sx={{ overflow: "hidden" }}
      >
        <MKBox
          component="img"
          src={bgImage}
          alt="pattern-lines"
          position="absolute"
          top={-50}
          left={0}
          width="100%"
          zIndex={1}
          opacity={0.2}
        />
        <Container sx={{ position: "relative", zIndex: 2, py: 12 }}>
          <Grid container item xs={12} md={7} justifyContent="center" mx="auto" textAlign="center">
            <MKTypography variant="h3" color="white">
              Wanna Contribute?
            </MKTypography>
            {/* <MKTypography variant="h3" color="white" mb={1}>
              UI Kit for ReactJS &amp; MUI?
            </MKTypography> */}
            <MKTypography variant="body2" color="white" mb={6}>
              Hit the button below to join and contribute to TechBuilder with your codings or other technical skills.
            </MKTypography>
            <MKButton
              variant="gradient"
              color="info"
              size="large"
              component="a"
              href="/community/join"
              sx={{ mb: 2 }}
            >
              Join
            </MKButton>
          </Grid>
        </Container>
      </MKBox>
      <Container>
        <Grid container item xs={6} mx="auto">
          <MKBox textAlign="center">
            <MKTypography variant="h3" mt={6} mb={3}>
              Available on these technologies
            </MKTypography>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={4} lg={2}>
                {/* <Tooltip title="Bootstrap 5 - Most popular front-end component library"> */}
                <Tooltip title="">
                  <MKBox
                    component="a"
                    href="https://www.techbuilder.in/product/material-kit"
                    target="_blank"
                  >
                    <MKBox
                      component="img"
                      src="https://s3.ap-south-1.amazonaws.com/techbuilder.in/public-assets/logos/node-js.png"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              <Grid item xs={4} lg={2}>
                {/* <Tooltip title="React is a free and open-source front-end JavaScript library for building user interfaces based on components"> */}
                <Tooltip title="">
                  <MKBox
                    component="a"
                    href="https://www.techbuilder.in/product/material-kit-react"
                    target="_blank"
                  >
                    <MKBox
                      component="img"
                      src="https://s3.ap-south-1.amazonaws.com/techbuilder.in/public-assets/logos/react-js.png"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              <Grid item xs={4} lg={2}>
                {/* <Tooltip title="Angular is a TypeScript-based, free and open-source web application framework led by the Angular Team at Google and by a community of individuals and corporations"> */}
                <Tooltip title="">
                  <MKBox
                    // opacity={0.5}
                    component="a"
                    href="#"
                    target="_blank"
                  // onClick={(e) => e.preventDefault()}
                  >
                    <MKBox
                      component="img"
                      src="https://s3.ap-south-1.amazonaws.com/techbuilder.in/public-assets/logos/angular.png"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              <Grid item xs={4} lg={2}>
                {/* <Tooltip title="Approachable. Builds on top of standard HTML, CSS and JavaScript with intuitive API and world-class documentation. · Performant"> */}
                <Tooltip title="">
                  <MKBox
                    // opacity={0.5}
                    component="a"
                    href="#"
                    target="_blank"
                  // onClick={(e) => e.preventDefault()}
                  >
                    <MKBox
                      component="img"
                      src="https://s3.ap-south-1.amazonaws.com/techbuilder.in/public-assets/logos/next-js.png"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              <Grid item xs={4} lg={2}>
                {/* <Tooltip title="Approachable. Builds on top of standard HTML, CSS and JavaScript with intuitive API and world-class documentation. · Performant"> */}
                <Tooltip title="">
                  <MKBox
                    // opacity={0.5}
                    component="a"
                    href="#"
                    target="_blank"
                  // onClick={(e) => e.preventDefault()}
                  >
                    <MKBox
                      component="img"
                      src="https://s3.ap-south-1.amazonaws.com/techbuilder.in/public-assets/logos/vue-js.png"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              <Grid item xs={4} lg={2}>
                {/* <Tooltip title="Sketch is the all-in-one platform for digital design — with collaborative design tools, prototyping and developer handoff. Get started for free"> */}
                <Tooltip title="">
                  <MKBox
                    // opacity={0.5}
                    component="a"
                    href="#"
                    target="_blank"
                  // onClick={(e) => e.preventDefault()}
                  >
                    <MKBox
                      component="img"
                      src="https://s3.ap-south-1.amazonaws.com/techbuilder.in/public-assets/logos/python.png"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
            </Grid>
          </MKBox>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Download;
